import { css } from "@compiled/react";

import AccountCreation, { Social } from "@/components/signup/account-creation";
import { SocialProvider } from "@/components/signup/utils";
import { wacToken } from "@/libraries/design/foundations";

import { InlineInputSubmitSocial } from "./components/inline-account-creation";

export type SignUpFormTextColor = "default" | "light";

export type UniformSignUpProps = {
    socialProviders?: SocialProvider[];
    textColor?: SignUpFormTextColor;
    inline?: boolean;
};

export const transformProviders = (providerList: string[]) => {
    return providerList.reduce(
        (previous, key) => ({ ...previous, [key.toLowerCase()]: key }),
        {}
    );
};

const lightTextColorCss = css({
    color: wacToken("color.neutral.light0")
});

const UniformSignUpForm = ({
    socialProviders,
    textColor = "default",
    inline = false
}: UniformSignUpProps) => {
    return (
        <div css={[textColor === "light" && lightTextColorCss]}>
            <AccountCreation
                Login={null}
                Separator={inline ? null : undefined}
                Error={inline ? null : undefined}
                Input={inline ? <InlineInputSubmitSocial /> : undefined}
                Submit={inline ? null : undefined}
                Social={
                    inline ? null : socialProviders?.length ? (
                        <Social
                            providers={transformProviders(socialProviders)}
                        />
                    ) : undefined
                }
            />
        </div>
    );
};

export default UniformSignUpForm;
